<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit">
      <main class="l-main">
        <div class="l-main-head">
          <div class="c-title u-w420">
            <div v-if="!messageId" class="c-title__text c-title__text--blue u-fs34">メッセージ内容の新規作成</div>
            <div v-else class="c-title__text c-title__text--blue u-fs34">メッセージ内容の編集</div>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--message-group">
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-input u-w50p">
                  <div class="c-input__title">
                    <span class="c-input__text c-input__text--required">【必須】</span>リマインダーIDを設定する
                  </div>
                  <input
                    v-model="reminderLabel"
                    class="c-input__item"
                    type="text"
                    name="reminder_id"
                    value=""
                    placeholder="例）cart_reminder-01"
                    :readonly="!!messageId"
                  />
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                  <ul
                    class="c-input__note"
                    style="font-size: 12px; color: #888; margin-top: 4px; line-height: 1.8; padding-left: 1.2em"
                  >
                    <li>リマインダーIDは一度設定すると変更できません</li>
                    <li>同じ名前のリマインダーIDは作成できません</li>
                    <li>100文字以内、半角英数字、ハイフン(-)、アンダースコア(_)のみ使用可能です</li>
                  </ul>
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">リマインダーへの補足</div>
                  <textarea
                    v-model="reminderNote"
                    class="c-input__item reminder-note-textarea"
                    name="reminder_note"
                    placeholder="このリマインダーの用途や目的などを記載してください"
                    rows="2"
                  ></textarea>
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 左カラム: フォーム -->
        <div class="l-main-content l-main-content--half l-main-content--left">
          <!-- セクション: メッセージ内容 -->
          <div class="p-message-edit">
            <div class="c-title">
              <div class="c-title__text u-fs24">配信されるメッセージ内容を作成する</div>
            </div>
            <div class="p-message-edit-list">
              <input type="hidden" name="deliver_mode" value="reminder" />

              <!-- トリガー配信 (互換性のため残す、deliverMode は常に reminder) -->
              <template v-if="deliverMode === 'immediate'">
                <div class="p-message-edit-list-cart__container">
                  <div class="p-message-edit-list__item">
                    <div class="c-input">
                      <div class="c-input__title">
                        <span class="c-input__text c-input__text--required">【必須】</span>タイトルを入力する
                      </div>
                      <input
                        v-model="message.messageTitle"
                        class="c-input__item"
                        type="text"
                        name="message_title"
                        placeholder="メッセージのタイトルを入力してください"
                        maxlength="300"
                      />
                      <div class="c-error c-error--balloon"><div class="c-error__text"></div></div>
                    </div>
                  </div>
                  <div class="p-message-edit-list__item">
                    <div class="c-textarea">
                      <div class="c-textarea__title">
                        <span class="c-input__text c-input__text--required">【必須】</span>メッセージの本文を入力する
                      </div>
                      <textarea
                        v-model="message.messageText"
                        class="c-textarea__item"
                        name="message_content"
                        placeholder="メッセージの本文を入力してください"
                        style="resize: vertical"
                      ></textarea>
                      <div class="c-error c-error--balloon"><div class="c-error__text"></div></div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- リマインダー配信: タブUI -->
              <template v-if="deliverMode === 'reminder'">
                <!-- タブナビゲーション -->
                <div class="reminder-tabs">
                  <div
                    v-for="(schedule, index) in schedules"
                    :key="'tab-' + index"
                    class="reminder-tabs__item"
                    :class="{ 'is-active': activeTab === index, 'has-error': tabHasError(index) }"
                    @click="activeTab = index"
                  >
                    {{ index + 1 }}通目
                  </div>
                  <div
                    v-if="schedules.length < 5"
                    class="reminder-tabs__add"
                    @click.stop="showAddPopup = !showAddPopup"
                  >
                    + 追加
                  </div>
                  <!-- 追加ポップアップ (tabs内、position:relativeの子要素) -->
                  <div v-if="showAddPopup" class="reminder-popup-overlay" @click="showAddPopup = false"></div>
                  <div v-if="showAddPopup" class="reminder-add-popup" @click.stop>
                    <div class="reminder-add-popup__title">新しいメッセージを追加</div>
                    <div class="reminder-add-popup__desc">前の通からの配信間隔を設定してください</div>
                    <div class="time-picker__input-wrap" style="margin-bottom: 10px">
                      <button
                        type="button"
                        class="time-picker__step-btn"
                        @click="addPopupMinutes = decrementMinutes(addPopupMinutes)"
                      >
                        −
                      </button>
                      <input
                        v-model="addPopupMinutes"
                        class="c-input__item time-picker__minutes-input"
                        type="text"
                        readonly
                      />
                      <button
                        type="button"
                        class="time-picker__step-btn"
                        @click="addPopupMinutes = incrementMinutes(addPopupMinutes)"
                      >
                        +
                      </button>
                      <span class="time-picker__unit-label">分後</span>
                    </div>
                    <div class="time-picker__chip-area" style="margin-bottom: 12px">
                      <template v-for="(group, gi) in timePresetGroups" :key="'add-g-' + gi">
                        <div class="time-picker__chip-group">
                          <template v-for="(p, pi) in group.items" :key="'add-c-' + gi + '-' + pi">
                            <button

                              type="button"
                              class="time-picker__chip"
                              :class="{ 'is-selected': String(addPopupMinutes) === String(p.value) }"
                              @click="addPopupMinutes = String(p.value)"
                            >
                              {{ p.label }}
                            </button>
                          </template>
                        </div>
                      </template>
                    </div>
                    <div style="display: flex; gap: 8px; justify-content: flex-end">
                      <button
                        type="button"
                        class="c-btn c-btn--gray u-h34 u-fs12"
                        style="width: auto; padding: 0 14px; min-width: 80px"
                        @click="showAddPopup = false"
                      >
                        <p class="c-btn__text">キャンセル</p>
                      </button>
                      <button
                        type="button"
                        class="c-btn c-btn--blue u-h34 u-fs12"
                        style="width: auto; padding: 0 14px; min-width: 80px"
                        @click="addScheduleWithTiming"
                      >
                        <p class="c-btn__text">追加</p>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- タブコンテンツ -->
                <div
                  v-for="(schedule, index) in schedules"
                  v-show="activeTab === index"
                  :key="'content-' + index"
                  :data-schedule-index="index"
                >
                  <!-- 配信タイミング -->
                  <div class="p-message-edit-list__item">
                    <div class="c-input">
                      <div class="c-input__title">
                        <span class="c-input__text c-input__text--required">【必須】</span>{{
                          index === 0
                            ? 'リマインダー登録から何分後に配信するか'
                            : index + '通目の配信から何分後に配信するか'
                        }}
                        <span
                          v-if="schedule.sendAfterMinutes"
                          class="time-picker__readable"
                        >（{{ formatMinutesReadable(schedule.sendAfterMinutes) }}）</span>
                      </div>
                      <div class="time-picker__input-wrap">
                        <button
                          type="button"
                          class="time-picker__step-btn"
                          @click="stepScheduleMinutes(index, -1)"
                        >
                          −
                        </button>
                        <input
                          v-model="schedule.sendAfterMinutes"
                          class="c-input__item time-picker__minutes-input"
                          type="text"
                          :name="'schedule_send_after_minutes_' + index"
                          readonly
                        />
                        <button
                          type="button"
                          class="time-picker__step-btn"
                          @click="stepScheduleMinutes(index, 1)"
                        >
                          +
                        </button>
                        <span class="time-picker__unit-label">分後</span>
                      </div>
                      <div class="time-picker__chip-area">
                        <template v-for="(group, gi) in timePresetGroups" :key="'g-' + gi">
                          <div class="time-picker__chip-group">
                            <template v-for="(p, pi) in group.items" :key="'c-' + gi + '-' + pi">
                              <button

                                type="button"
                                class="time-picker__chip"
                                :class="{ 'is-selected': String(schedule.sendAfterMinutes) === String(p.value) }"
                                @click="setMinutePreset(index, p.value)"
                              >
                                {{ p.label }}
                              </button>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div class="c-error c-error--balloon" data-error-anchor="time-picker__minutes-input">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>

                  <!-- タイトル -->
                  <div class="p-message-edit-list__item">
                    <div class="c-input">
                      <div class="c-input__title">
                        <span class="c-input__text c-input__text--required">【必須】</span>タイトルを入力する
                      </div>
                      <input
                        v-model="schedule.messageTitle"
                        class="c-input__item"
                        type="text"
                        :name="'schedule_title_' + index"
                        placeholder="メッセージのタイトルを入力してください"
                      />
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>

                  <!-- 本文 -->
                  <div class="p-message-edit-list__item">
                    <div class="c-textarea">
                      <div class="c-textarea__title">
                        <span class="c-input__text c-input__text--required">【必須】</span>メッセージの本文を入力する
                      </div>
                      <textarea
                        v-model="schedule.messageText"
                        class="c-textarea__item"
                        :name="'schedule_message_' + index"
                        placeholder="メッセージの本文を入力してください"
                        style="resize: vertical"
                      ></textarea>
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>

                  <!-- 遷移先URL -->
                  <div class="p-message-edit-list__item">
                    <div class="c-input">
                      <div class="c-input__title">
                        <span class="c-input__text c-input__text--required">【必須】</span>遷移先のURLを設定する
                      </div>
                      <input
                        v-model="schedule.clickUrl"
                        class="c-input__item"
                        type="text"
                        :name="'schedule_click_url_' + index"
                        placeholder="例）https://webpush.jp/"
                      />
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>

                  <!-- 画像・アイコン設定 (アコーディオン) -->
                  <div class="reminder-image-section">
                    <div class="reminder-image-section__outer" :class="{ 'is-open': !!imageAccordionOpen[index] }">
                      <div v-if="!imageAccordionOpen[index]" class="reminder-image-section__toggle-wrap">
                        <button
                          type="button"
                          class="reminder-image-section__toggle-btn"
                          @click="toggleImageAccordion(index)"
                        >
                          画像・アイコン設定をすべて表示する
                        </button>
                      </div>
                      <div
                        v-if="!imageAccordionOpen[index]"
                        class="reminder-image-section__mask"
                        @click="toggleImageAccordion(index)"
                      ></div>
                      <div class="reminder-image-section__body" :class="{ 'is-open': !!imageAccordionOpen[index] }">
                        <!-- 通知アイコン -->
                        <div class="p-message-edit-list__item">
                          <div class="c-upload">
                            <div class="c-upload__title" style="width: auto">通知アイコンを設定する</div>
                            <label class="c-upload__label">
                              <div class="c-upload__image">
                                <img v-if="schedule.iconUrl" :src="schedule.iconUrl" />
                                <div v-else class="c-upload__noimage">
                                  <div class="c-icon c-icon--gray-3 u-wh30">
                                    <svg
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                    >
                                      <use xlink:href="/assets/img/sprite.svg#photo" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div class="c-upload__data">
                                <input
                                  type="file"
                                  :name="'schedule_icon_' + index"
                                  placeholder="ファイルの選択"
                                  @change="selectIconFile($event, index)"
                                />
                                <span class="c-upload__btn">ファイルの選択</span>
                                <div class="c-upload__text c-upload__text--spec">
                                  サイズ：縦64x横64px～縦192x横192px<br />
                                  容量：5KB以内奨励(最大8KB)<br />
                                  形式：PNG奨励(JPG可)
                                </div>
                              </div>
                            </label>
                            <div class="c-error" :class="{ 'is-active': schedule.errors.icon !== '' }">
                              <div class="c-error__text">{{ schedule.errors.icon }}</div>
                            </div>
                          </div>
                        </div>

                        <!-- 追加大型画像 -->
                        <div class="p-message-edit-list__item">
                          <div class="c-upload">
                            <div class="c-upload__title" style="width: auto">追加大型画像を設定する</div>
                            <div style="position: relative; width: 470px">
                              <label class="c-upload__label">
                                <div class="c-upload__image">
                                  <img v-if="schedule.largeImageUrl" :src="schedule.largeImageUrl" />
                                  <div v-else class="c-upload__noimage">
                                    <div class="c-icon c-icon--gray-3 u-wh30">
                                      <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                      >
                                        <use xlink:href="/assets/img/sprite.svg#photo" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div class="c-upload__data">
                                  <input
                                    type="file"
                                    :name="'schedule_large_image_' + index"
                                    placeholder="ファイルの選択"
                                    @change="selectLargeImageFile($event, index)"
                                  />
                                  <span class="c-upload__btn">ファイルの選択</span>
                                  <div class="c-upload__text c-upload__text--spec">
                                    サイズ：縦240x横480px<br />
                                    容量：128KB以内奨励<br />
                                    形式：PNG奨励(JPG可)
                                  </div>
                                </div>
                              </label>
                              <span
                                class="c-upload__btn"
                                style="position: absolute; top: 28px; left: 270px; cursor: pointer"
                                @click="clearLargeImageFile(index)"
                              >クリア</span>
                            </div>
                            <div class="c-error" :class="{ 'is-active': schedule.errors.largeImage !== '' }">
                              <div class="c-error__text">{{ schedule.errors.largeImage }}</div>
                            </div>
                          </div>
                        </div>

                        <!-- ステータスアイコン -->
                        <div class="p-message-edit-list__item">
                          <div class="c-upload">
                            <div class="c-upload__title" style="width: auto">ステータスアイコンを設定する</div>
                            <div style="position: relative">
                              <label class="c-upload__label">
                                <div class="c-upload__image">
                                  <img
                                    v-if="schedule.badgeUrl"
                                    :src="schedule.badgeUrl"
                                    class="uploaded_transparent_image"
                                  />
                                  <div v-else class="c-upload__noimage">
                                    <div class="c-icon c-icon--gray-3 u-wh30">
                                      <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                      >
                                        <use xlink:href="/assets/img/sprite.svg#photo" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div class="c-upload__data">
                                  <input
                                    type="file"
                                    :name="'schedule_badge_' + index"
                                    placeholder="ファイルの選択"
                                    @change="selectBadgeFile($event, index)"
                                  />
                                  <span class="c-upload__btn">ファイルの選択</span>
                                  <div class="c-upload__text c-upload__text--spec">
                                    サイズ：縦72x横72px～縦128x横128px<br />
                                    5KB以内奨励(最大8KB)<br />
                                    形式：PNG
                                  </div>
                                </div>
                              </label>
                              <span
                                class="c-upload__btn"
                                style="position: absolute; top: 28px; left: 270px; cursor: pointer"
                                @click="clearBadgeFile(index)"
                              >クリア</span>
                            </div>
                            <div class="c-error" :class="{ 'is-active': schedule.errors.badge !== '' }">
                              <div class="c-error__text">{{ schedule.errors.badge }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 通知動作設定 -->
                  <div class="p-message-edit-list__item" style="margin-top: 16px">
                    <div class="c-checkbox">
                      <label class="c-checkbox__label">
                        <input
                          v-model="schedule.requireInteraction"
                          type="checkbox"
                          true-value="1"
                          false-value="0"
                        />
                        <div class="c-checkbox__item">
                          <div class="c-checkbox__box"></div>
                          <div class="c-checkbox__box-label">一定時間で通知を自動で非表示にする</div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- セクション: 配信時間帯 -->
          <div class="p-message-edit" style="margin-top: 3px">
            <div class="c-title" style="margin-bottom: 6px">
              <div class="c-title__text u-fs20">配信時間帯を設定する</div>
            </div>
            <div class="p-message-edit-list">
              <div class="p-message-edit-list__item p-message-edit-list__item--set-cart-non-working-hours">
                <div
                  class="c-upload__text c-upload__text--spec"
                  style="line-height: 1.5; margin-top: 0; margin-bottom: 10px"
                >
                  メッセージを配信する時間帯を設定します。<br />例えば07:00〜23:00に設定するとその時間帯のみメッセージを配信します。
                </div>
                <working-time-picker
                  :start-time="workingStartTime"
                  :end-time="workingEndTime"
                  @update:start-time="workingStartTime = $event"
                  @update:end-time="workingEndTime = $event"
                />
              </div>
            </div>
          </div>

          <!-- セクション: 差し込みテキスト -->
          <div class="p-message-edit" style="margin-top: 3px">
            <div class="c-title" style="margin-bottom: 6px">
              <div class="c-title__text u-fs20">差し込みテキスト</div>
            </div>
            <div class="p-message-edit-list">
              <div class="p-message-edit-list__item" style="margin-bottom: 12px">
                <div class="c-upload__text c-upload__text--spec" style="line-height: 1.5; margin-top: 0">
                  ユーザーに配信するメッセージに動的に値を設定できます。<br />
                  例えばキー名を「商品」を設定した場合、タイトル・本文・遷移先URLに
                  <span v-pre class="placeholder-key-highlight">{{商品}}</span>
                  と記述すると、ユーザーごとに値に置換してメッセージを配信します。
                </div>
              </div>
              <div class="p-message-edit-list-cart__container">
                <div v-for="(ph, index) in placeholders" :key="'ph-' + index" class="p-message-edit-list__item">
                  <div
                    style="display: flex; align-items: flex-start; gap: 16px"
                    :class="{ 'placeholder-row--no-title': index > 0 }"
                  >
                    <div class="c-input" style="flex: 1; position: relative">
                      <div v-if="index === 0" class="c-input__title">キー名</div>
                      <input
                        v-model="ph.placeholderKey"
                        class="c-input__item"
                        type="text"
                        :name="'placeholder_key_' + index"
                        placeholder="例）商品"
                      />
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                    <div class="c-input" style="flex: 1; position: relative">
                      <div v-if="index === 0" class="c-input__title">デフォルトテキスト</div>
                      <input
                        v-model="ph.defaultValue"
                        class="c-input__item"
                        type="text"
                        :name="'placeholder_default_' + index"
                        placeholder="デフォルト値を入力"
                      />
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                    <div
                      class="placeholder-remove-btn"
                      :style="{ 'padding-top': index === 0 ? '47px' : '16px' }"
                      @click="removePlaceholder(index)"
                    >
                      <div class="c-icon c-icon--gray-3 u-wh16">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <use xlink:href="/assets/img/sprite.svg#close" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item--add-message">
                <button class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14" type="button" @click="addPlaceholder">
                  <div class="c-icon-circle c-icon-circle--blue u-wh20">
                    <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#plus" />
                      </svg>
                    </div>
                  </div>
                  <p class="c-btn__text">差し込みテキストを追加する</p>
                </button>
              </div>
            </div>
          </div>

          <!-- セクション: 差し込み大型画像URL -->
          <div class="p-message-edit" style="margin-top: 3px">
            <div class="p-message-edit-list">
              <div class="p-message-edit-list__item">
                <div class="c-checkbox">
                  <label class="c-checkbox__label">
                    <input
                      v-model="useLargeImagePlaceholder"
                      type="checkbox"
                      true-value="1"
                      false-value="0"
                    />
                    <div class="c-checkbox__item">
                      <div class="c-checkbox__box"></div>
                      <div class="c-checkbox__box-label">差し込み大型画像URLを使用する</div>
                    </div>
                  </label>
                </div>
                <div
                  class="c-upload__text c-upload__text--spec"
                  style="line-height: 1.5; margin-top: 8px; margin-left: 24px"
                >
                  ユーザーごとに画像URLを動的に差し替えて配信します
                </div>
              </div>
            </div>
          </div>

          <!-- 画像トリミングモーダル -->
          <image-cropper-modal ref="imageCropperModal" @cropped="onIconCropped" @cancelled="onIconCropCancelled" />
          <image-cropper-modal
            ref="imageCropperModalLarge"
            modal-id="imageCropperModalLarge"
            modal-title="大型画像最適化"
            modal-description="画像サイズが128KBを超えています。<br>大型画像に使用する範囲を選択してください。<br>(横480×縦240px、128KB以下に自動変換されます)"
            :aspect-ratio="2"
            :output-width="480"
            :output-height="240"
            :max-file-size="131072"
            preferred-format="png"
            @cropped="onLargeImageCropped"
            @cancelled="onLargeImageCropCancelled"
          />
        </div>

        <!-- 右カラム: プレビュー -->
        <div class="l-main-content l-main-content--half l-main-content--right">
          <div class="p-message-preview">
            <div class="c-title c-title--left u-text-white-1">
              <div class="c-title__text u-fs--l">プレビュー</div>
              <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
            </div>

            <ul class="c-tab-list">
              <li
                class="c-tab-list__item"
                :class="{ 'is-active': previewType == 'desktop' }"
                @click="changePreviewType('desktop')"
              >
                PCでの配信例
              </li>
              <li
                class="c-tab-list__item"
                :class="{ 'is-active': previewType == 'mobile' }"
                @click="changePreviewType('mobile')"
              >
                Androidでの配信例
              </li>
            </ul>

            <!-- PC プレビュー -->
            <div v-show="previewType == 'desktop'" class="p-message-preview-list preview-list--compact">
              <template v-if="deliverMode === 'reminder' && previewSchedules.length > 0">
                <template v-for="(schedule, idx) in previewSchedules" :key="'desktop-sep-' + idx">
                  <div class="preview-schedule-separator">
                    <button type="button" class="preview-timing-btn" @click.stop="openTimingEdit(idx)">
                      ↓ {{ idx === 0 ? 'リマインダー登録から' : ''
                      }}{{ formatMinutesReadable(schedule.sendAfterMinutes) }}後 ↓
                    </button>
                    <!-- タイミング編集ポップアップ -->
                    <div v-if="editTimingIdx === idx" class="preview-timing-popup" @click.stop>
                      <div class="reminder-add-popup__title">配信タイミングを変更</div>
                      <div class="time-picker__input-wrap" style="margin-bottom: 10px">
                        <button
                          type="button"
                          class="time-picker__step-btn"
                          @click="editTimingMinutes = decrementMinutes(editTimingMinutes)"
                        >
                          −
                        </button>
                        <input
                          v-model="editTimingMinutes"
                          class="c-input__item time-picker__minutes-input"
                          type="text"
                          readonly
                        />
                        <button
                          type="button"
                          class="time-picker__step-btn"
                          @click="editTimingMinutes = incrementMinutes(editTimingMinutes)"
                        >
                          +
                        </button>
                        <span class="time-picker__unit-label">分後</span>
                      </div>
                      <div class="time-picker__chip-area" style="margin-bottom: 12px">
                        <template v-for="(group, gi) in timePresetGroups" :key="'te-g-' + gi">
                          <div class="time-picker__chip-group">
                            <template v-for="(p, pi) in group.items" :key="'te-c-' + gi + '-' + pi">
                              <button

                                type="button"
                                class="time-picker__chip"
                                :class="{ 'is-selected': String(editTimingMinutes) === String(p.value) }"
                                @click="editTimingMinutes = String(p.value)"
                              >
                                {{ p.label }}
                              </button>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div style="display: flex; gap: 8px; justify-content: flex-end">
                        <button
                          type="button"
                          class="c-btn c-btn--gray u-h34 u-fs12"
                          style="width: auto; padding: 0 14px; min-width: 80px"
                          @click="editTimingIdx = null"
                        >
                          <p class="c-btn__text">キャンセル</p>
                        </button>
                        <button
                          type="button"
                          class="c-btn c-btn--blue u-h34 u-fs12"
                          style="width: auto; padding: 0 14px; min-width: 80px"
                          @click="saveTimingEdit(idx)"
                        >
                          <p class="c-btn__text">保存</p>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="preview-schedule-label">
                    <span>{{ idx + 1 }}通目</span>
                    <button
                      v-if="idx > 0"
                      type="button"
                      class="preview-action-btn preview-action-btn--delete"
                      @click="confirmDeleteSchedule(idx)"
                    >
                      メッセージの削除
                    </button>
                  </div>
                  <div

                    class="preview-card-interactive"
                    @click="onPreviewCardClick($event, idx)"
                  >
                    <message-preview
                      :title="previewDisplayTitle(schedule)"
                      :text="previewDisplayText(schedule)"
                      :url="schedule.clickUrl"
                      :icon-url="getScheduleIconUrl(schedule)"
                      :large-image-url="schedule.largeImageUrl"
                    />
                  </div>
                </template>
              </template>
              <template v-else>
                <message-preview
                  :title="previewTitle || '(未入力)'"
                  :text="previewText || '(未入力)'"
                  :url="''"
                  :icon-url="previewIconUrl"
                  :large-image-url="''"
                />
              </template>
              <!-- プレビュー内追加ボタン -->
              <div v-if="deliverMode === 'reminder' && schedules.length < 5" class="preview-add-wrap">
                <button type="button" class="preview-add-btn" @click.stop="showPreviewAddPopup = !showPreviewAddPopup">
                  <div class="c-icon-circle c-icon-circle--primary u-wh16">
                    <div class="c-icon-circle__item c-icon-circle__item--white u-wh10">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#plus" />
                      </svg>
                    </div>
                  </div>
                  メッセージを追加
                </button>
                <!-- プレビュー内追加ポップアップ -->
                <div
                  v-if="showPreviewAddPopup"
                  class="reminder-popup-overlay"
                  @click="showPreviewAddPopup = false"
                ></div>
                <div v-if="showPreviewAddPopup" class="preview-add-popup" @click.stop>
                  <div class="reminder-add-popup__title">新しいメッセージを追加</div>
                  <div class="reminder-add-popup__desc">前の通からの配信間隔を設定してください</div>
                  <div class="time-picker__input-wrap" style="margin-bottom: 10px">
                    <button
                      type="button"
                      class="time-picker__step-btn"
                      @click="previewAddPopupMinutes = decrementMinutes(previewAddPopupMinutes)"
                    >
                      −
                    </button>
                    <input
                      v-model="previewAddPopupMinutes"
                      class="c-input__item time-picker__minutes-input"
                      type="text"
                      readonly
                    />
                    <button
                      type="button"
                      class="time-picker__step-btn"
                      @click="previewAddPopupMinutes = incrementMinutes(previewAddPopupMinutes)"
                    >
                      +
                    </button>
                    <span class="time-picker__unit-label">分後</span>
                  </div>
                  <div class="time-picker__chip-area" style="margin-bottom: 12px">
                    <template v-for="(group, gi) in timePresetGroups" :key="'pa-g-' + gi">
                      <div class="time-picker__chip-group">
                        <template v-for="(p, pi) in group.items" :key="'pa-c-' + gi + '-' + pi">
                          <button

                            type="button"
                            class="time-picker__chip"
                            :class="{ 'is-selected': String(previewAddPopupMinutes) === String(p.value) }"
                            @click="previewAddPopupMinutes = String(p.value)"
                          >
                            {{ p.label }}
                          </button>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div style="display: flex; gap: 8px; justify-content: flex-end">
                    <button
                      type="button"
                      class="c-btn c-btn--gray u-h34 u-fs12"
                      style="width: auto; padding: 0 14px; min-width: 80px"
                      @click="showPreviewAddPopup = false"
                    >
                      <p class="c-btn__text">キャンセル</p>
                    </button>
                    <button
                      type="button"
                      class="c-btn c-btn--blue u-h34 u-fs12"
                      style="width: auto; padding: 0 14px; min-width: 80px"
                      @click="addScheduleFromPreview"
                    >
                      <p class="c-btn__text">追加</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Android プレビュー -->
            <div v-show="previewType == 'mobile'" class="p-message-preview-list preview-list--compact">
              <template v-if="deliverMode === 'reminder' && previewSchedules.length > 0">
                <template v-for="(schedule, idx) in previewSchedules" :key="'mobile-sep-' + idx">
                  <div class="preview-schedule-separator">
                    <button type="button" class="preview-timing-btn" @click.stop="openTimingEdit(idx)">
                      ↓ {{ idx === 0 ? 'リマインダー登録から' : ''
                      }}{{ formatMinutesReadable(schedule.sendAfterMinutes) }}後 ↓
                    </button>
                    <div
                      v-if="editTimingIdx === idx && previewType === 'mobile'"
                      class="preview-timing-popup"
                      @click.stop
                    >
                      <div class="reminder-add-popup__title">配信タイミングを変更</div>
                      <div class="time-picker__input-wrap" style="margin-bottom: 10px">
                        <button
                          type="button"
                          class="time-picker__step-btn"
                          @click="editTimingMinutes = decrementMinutes(editTimingMinutes)"
                        >
                          −
                        </button>
                        <input
                          v-model="editTimingMinutes"
                          class="c-input__item time-picker__minutes-input"
                          type="text"
                          readonly
                        />
                        <button
                          type="button"
                          class="time-picker__step-btn"
                          @click="editTimingMinutes = incrementMinutes(editTimingMinutes)"
                        >
                          +
                        </button>
                        <span class="time-picker__unit-label">分後</span>
                      </div>
                      <div class="time-picker__chip-area" style="margin-bottom: 12px">
                        <template v-for="(group, gi) in timePresetGroups" :key="'tem-g-' + gi">
                          <div class="time-picker__chip-group">
                            <template v-for="(p, pi) in group.items" :key="'tem-c-' + gi + '-' + pi">
                              <button

                                type="button"
                                class="time-picker__chip"
                                :class="{ 'is-selected': String(editTimingMinutes) === String(p.value) }"
                                @click="editTimingMinutes = String(p.value)"
                              >
                                {{ p.label }}
                              </button>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div style="display: flex; gap: 8px; justify-content: flex-end">
                        <button
                          type="button"
                          class="c-btn c-btn--gray u-h34 u-fs12"
                          style="width: auto; padding: 0 14px; min-width: 80px"
                          @click="editTimingIdx = null"
                        >
                          <p class="c-btn__text">キャンセル</p>
                        </button>
                        <button
                          type="button"
                          class="c-btn c-btn--blue u-h34 u-fs12"
                          style="width: auto; padding: 0 14px; min-width: 80px"
                          @click="saveTimingEdit(idx)"
                        >
                          <p class="c-btn__text">保存</p>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="preview-schedule-label">
                    <span>{{ idx + 1 }}通目</span>
                    <button
                      v-if="idx > 0"
                      type="button"
                      class="preview-action-btn preview-action-btn--delete"
                      @click="confirmDeleteSchedule(idx)"
                    >
                      メッセージの削除
                    </button>
                  </div>
                  <div

                    class="preview-card-interactive"
                    @click="onPreviewCardClick($event, idx)"
                  >
                    <message-preview-sp
                      :title="previewDisplayTitle(schedule)"
                      :text="previewDisplayText(schedule)"
                      :url="schedule.clickUrl"
                      :icon-url="getScheduleIconUrl(schedule)"
                      :large-image-url="schedule.largeImageUrl"
                      :badge-url="getScheduleBadgeUrl(schedule)"
                    />
                  </div>
                </template>
              </template>
              <template v-else>
                <message-preview-sp
                  :title="previewTitle || '(未入力)'"
                  :text="previewText || '(未入力)'"
                  :url="''"
                  :icon-url="previewIconUrl"
                  :large-image-url="''"
                  :badge-url="previewBadgeUrl"
                />
              </template>
              <div v-if="deliverMode === 'reminder' && schedules.length < 5" class="preview-add-wrap">
                <button type="button" class="preview-add-btn" @click.stop="showPreviewAddPopup = !showPreviewAddPopup">
                  <div class="c-icon-circle c-icon-circle--primary u-wh16">
                    <div class="c-icon-circle__item c-icon-circle__item--white u-wh10">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#plus" />
                      </svg>
                    </div>
                  </div>
                  メッセージを追加
                </button>
                <div
                  v-if="showPreviewAddPopup"
                  class="reminder-popup-overlay"
                  @click="showPreviewAddPopup = false"
                ></div>
                <div v-if="showPreviewAddPopup" class="preview-add-popup" @click.stop>
                  <div class="reminder-add-popup__title">新しいメッセージを追加</div>
                  <div class="reminder-add-popup__desc">前の通からの配信間隔を設定してください</div>
                  <div class="time-picker__input-wrap" style="margin-bottom: 10px">
                    <button
                      type="button"
                      class="time-picker__step-btn"
                      @click="previewAddPopupMinutes = decrementMinutes(previewAddPopupMinutes)"
                    >
                      −
                    </button>
                    <input
                      v-model="previewAddPopupMinutes"
                      class="c-input__item time-picker__minutes-input"
                      type="text"
                      readonly
                    />
                    <button
                      type="button"
                      class="time-picker__step-btn"
                      @click="previewAddPopupMinutes = incrementMinutes(previewAddPopupMinutes)"
                    >
                      +
                    </button>
                    <span class="time-picker__unit-label">分後</span>
                  </div>
                  <div class="time-picker__chip-area" style="margin-bottom: 12px">
                    <template v-for="(group, gi) in timePresetGroups" :key="'pam-g-' + gi">
                      <div class="time-picker__chip-group">
                        <template v-for="(p, pi) in group.items" :key="'pam-c-' + gi + '-' + pi">
                          <button

                            type="button"
                            class="time-picker__chip"
                            :class="{ 'is-selected': String(previewAddPopupMinutes) === String(p.value) }"
                            @click="previewAddPopupMinutes = String(p.value)"
                          >
                            {{ p.label }}
                          </button>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div style="display: flex; gap: 8px; justify-content: flex-end">
                    <button
                      type="button"
                      class="c-btn c-btn--gray u-h34 u-fs12"
                      style="width: auto; padding: 0 14px; min-width: 80px"
                      @click="showPreviewAddPopup = false"
                    >
                      <p class="c-btn__text">キャンセル</p>
                    </button>
                    <button
                      type="button"
                      class="c-btn c-btn--blue u-h34 u-fs12"
                      style="width: auto; padding: 0 14px; min-width: 80px"
                      @click="addScheduleFromPreview"
                    >
                      <p class="c-btn__text">追加</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

    <!-- 下部アクションバー -->
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button class="c-btn c-btn--block u-w146 u-fs24" type="button" @click="onQuitClick">
              <p v-if="!messageId" class="c-btn__text">作成をやめる</p>
              <p v-else class="c-btn__text">編集をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn }"
            :disabled="isLoadingNextBtn"
            type="button"
            @click="onNextClick"
          >
            <p class="c-btn__text">次へ（配信条件の設定）</p>
          </button>
        </div>
      </div>
    </div>

    <!-- 削除確認ダイアログ -->
    <div v-if="deleteConfirmIndex !== null" class="reminder-confirm-overlay" @click="deleteConfirmIndex = null">
      <div class="reminder-confirm-dialog" @click.stop>
        <div class="reminder-confirm-dialog__title">メッセージの削除</div>
        <div class="reminder-confirm-dialog__body">{{ deleteConfirmIndex + 1 }}通目のメッセージを削除しますか？</div>
        <div class="reminder-confirm-dialog__btns">
          <button type="button" class="c-btn c-btn--gray u-w140 u-h34 u-fs14" @click="deleteConfirmIndex = null">
            <p class="c-btn__text">キャンセル</p>
          </button>
          <button type="button" class="c-btn c-btn--blue u-w140 u-h34 u-fs14" @click="doDeleteSchedule">
            <p class="c-btn__text">削除する</p>
          </button>
        </div>
      </div>
    </div>

    <!-- エラーモーダル -->
    <error-modal :is-active="isError" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </form>
</template>

<script>
import axios from 'axios';
import ImageCropperModal from '../organisms/ImageCropperModal.vue';

export default {
  components: { ImageCropperModal },
  props: {
    csrfToken: String,
    messageInfo: Object,
  },
  data() {
    return {
      errorMessage: '',
      isError: false,
      isLoadingSaveBtn: false,
      isLoadingNextBtn: false,
      message: {
        messageTitle: null,
        messageText: null,
      },
      deliverMode: 'reminder',
      workingStartTime: 700,
      workingEndTime: 2300,
      timePresetGroups: [
        {
          items: [
            { label: '5分後', value: 5 },
            { label: '10分後', value: 10 },
            { label: '30分後', value: 30 },
            { label: '45分後', value: 45 },
          ],
        },
        {
          items: [
            { label: '1時間後', value: 60 },
            { label: '3時間後', value: 180 },
            { label: '6時間後', value: 360 },
            { label: '12時間後', value: 720 },
          ],
        },
        {
          items: [
            { label: '1日後', value: 1440 },
            { label: '3日後', value: 4320 },
            { label: '7日後', value: 10080 },
            { label: '10日後', value: 14400 },
            { label: '15日後', value: 21600 },
          ],
        },
      ],
      schedules: [
        {
          sendAfterMinutes: '5',
          messageTitle: null,
          messageText: null,
          clickUrl: null,
          requireInteraction: '0',
          iconUrl: null,
          selectedIconFile: null,
          largeImageUrl: null,
          selectedLargeImageFile: null,
          badgeUrl: null,
          selectedBadgeFile: null,
          errors: { icon: '', largeImage: '', badge: '' },
        },
      ],
      placeholders: [{ placeholderKey: '', defaultValue: '' }],
      useLargeImagePlaceholder: '0',
      messageId: null,
      reminderLabel: null,
      reminderNote: null,
      previewType: 'desktop',
      errors: {},
      acceptableMimeTypes: ['image/png', 'image/jpeg', 'image/gif'],
      currentCropScheduleIndex: null,
      currentCropInput: null,
      // タブUI
      activeTab: 0,
      // 追加ポップアップ
      showAddPopup: false,
      addPopupMinutes: '5',
      // 画像アコーディオン開閉状態
      imageAccordionOpen: {},
      // 削除確認ダイアログ
      deleteConfirmIndex: null,
      // タイミング編集ポップアップ
      editTimingIdx: null,
      editTimingMinutes: '5',
      // プレビュー内追加ポップアップ
      showPreviewAddPopup: false,
      previewAddPopupMinutes: '5',
      // バリデーションエラーのあるタブインデックス
      tabErrorIndices: [],
    };
  },
  computed: {
    previewIconUrl: function () {
      if (this.schedules.length > 0 && this.schedules[0].iconUrl) {
        return this.schedules[0].iconUrl;
      }
      return this.messageInfo.defaultIconUrl;
    },
    previewBadgeUrl: function () {
      if (this.schedules.length > 0 && this.schedules[0].badgeUrl) {
        return this.schedules[0].badgeUrl;
      }
      return this.messageInfo.defaultBadgeUrl;
    },
    previewTitle: function () {
      let title =
        this.deliverMode === 'immediate'
          ? this.message.messageTitle
          : this.schedules.length > 0
            ? this.schedules[0].messageTitle
            : null;
      return this.replacePlaceholders(title);
    },
    previewText: function () {
      let text =
        this.deliverMode === 'immediate'
          ? this.message.messageText
          : this.schedules.length > 0
            ? this.schedules[0].messageText
            : null;
      return this.replacePlaceholders(text);
    },
    previewSchedules: function () {
      if (this.deliverMode !== 'reminder') return [];
      return this.schedules;
    },
  },
  watch: {
    schedules: {
      handler: function () {
        if (this.tabErrorIndices.length === 0) return;
        this.tabErrorIndices = this.tabErrorIndices.filter((idx) => {
          let s = this.schedules[idx];
          if (!s) return false;
          let hasEmpty =
            s.sendAfterMinutes == null || s.sendAfterMinutes === '' || !s.messageTitle || !s.messageText || !s.clickUrl;
          return hasEmpty;
        });
      },
      deep: true,
    },
  },
  mounted: function () {
    import('../../funcs/pages/message-add').then((module) => {
      module.MessageAdd();
    });

    if (this.messageInfo.message) {
      let msg = this.messageInfo.message;

      if (this.messageInfo.type == 'edit') {
        this.messageId = msg.message_id;
      }
      this.reminderLabel = msg.reminder_id;
      this.reminderNote = msg.reminder_note || null;
      this.message.messageTitle = msg.message_title;
      this.message.messageText = msg.message_text;
      this.workingStartTime = msg.working_start_time != null ? Number(msg.working_start_time) : 700;
      this.workingEndTime = msg.working_end_time != null ? Number(msg.working_end_time) : 2300;

      if (msg.schedules && msg.schedules.length > 0) {
        this.deliverMode = 'reminder';
        this.schedules = msg.schedules.map((s) => ({
          sendAfterMinutes: s.send_after_minutes != null ? String(s.send_after_minutes) : null,
          messageTitle: s.message_title,
          messageText: s.message_text,
          clickUrl: s.click_url || null,
          requireInteraction: String(s.require_interaction || '0'),
          iconUrl: s.icon_url || null,
          selectedIconFile: null,
          largeImageUrl: s.large_image_url || null,
          selectedLargeImageFile: null,
          badgeUrl: s.badge_image_url || null,
          selectedBadgeFile: null,
          errors: { icon: '', largeImage: '', badge: '' },
        }));
      }

      if (msg.placeholders && msg.placeholders.length > 0) {
        this.placeholders = msg.placeholders.map((p) => ({
          placeholderKey: p.placeholder_key,
          defaultValue: p.default_value,
        }));
      } else {
        this.placeholders = [{ placeholderKey: '', defaultValue: '' }];
      }

      this.useLargeImagePlaceholder = String(msg.use_large_image_placeholder || '0');
    }
  },
  methods: {
    formatMinutesReadable: function (minutes) {
      let m = parseInt(minutes);
      if (isNaN(m) || m < 0) return '';
      let days = Math.floor(m / 1440);
      let hours = Math.floor((m % 1440) / 60);
      let mins = m % 60;
      let parts = [];
      if (days > 0) parts.push(days + '日');
      if (hours > 0) parts.push(hours + '時間');
      if (mins > 0 || parts.length === 0) parts.push(mins + '分');
      return parts.join(' ');
    },
    setMinutePreset: function (index, value) {
      this.schedules[index].sendAfterMinutes = String(value);
      var el = this.$el.querySelector('[name="schedule_send_after_minutes_' + index + '"]');
      if (el) {
        var container = el.closest('.c-input');
        if (container) {
          this.clearErrorByTargetElement(container);
        }
      }
    },
    // +ボタン: 現在値以上の次の 5 の倍数へ。上限 43200 分 (30 日)。
    // 非 5 倍数の既存値も次の 5 倍数へ丸める (例: 3 → 5, 8 → 10)。
    incrementMinutes: function (current) {
      var n = parseInt(current) || 0;
      return String(Math.min(43200, Math.floor(n / 5) * 5 + 5));
    },
    // -ボタン: 現在値以下の直前の 5 の倍数へ。下限 5 分 (0 は不可)。
    // 非 5 倍数の既存値も直前の 5 倍数へ丸める (例: 8 → 5, 12 → 10)。
    decrementMinutes: function (current) {
      var n = parseInt(current) || 0;
      return String(Math.max(5, Math.ceil(n / 5) * 5 - 5));
    },
    stepScheduleMinutes: function (index, delta) {
      var current = this.schedules[index].sendAfterMinutes;
      this.schedules[index].sendAfterMinutes =
        delta > 0 ? this.incrementMinutes(current) : this.decrementMinutes(current);
      var el = this.$el.querySelector('[name="schedule_send_after_minutes_' + index + '"]');
      if (el) {
        var container = el.closest('.c-input');
        if (container) {
          this.clearErrorByTargetElement(container);
        }
      }
    },
    onQuitClick: function () {
      location.href = this.messageInfo.listUrl;
    },
    onNextClick: function () {
      if (this.validate()) {
        this.isLoadingNextBtn = true;
        this.saveMessage(this.messageInfo.addConditionUrl);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
        this.scrollToFirstError();
      }
    },
    changePreviewType: function (type) {
      this.previewType = type;
    },

    // 前のスケジュールの内容をコピーした新規スケジュールを生成
    createScheduleFromPrevious: function (minutes) {
      let prev = this.schedules.length > 0 ? this.schedules[this.schedules.length - 1] : null;
      return {
        sendAfterMinutes: minutes,
        messageTitle: prev ? prev.messageTitle : null,
        messageText: prev ? prev.messageText : null,
        clickUrl: prev ? prev.clickUrl : null,
        requireInteraction: prev ? prev.requireInteraction : '0',
        iconUrl: prev ? prev.iconUrl : null,
        selectedIconFile: null,
        largeImageUrl: prev ? prev.largeImageUrl : null,
        selectedLargeImageFile: null,
        badgeUrl: prev ? prev.badgeUrl : null,
        selectedBadgeFile: null,
        errors: { icon: '', largeImage: '', badge: '' },
      };
    },
    // タブ関連
    addScheduleWithTiming: function () {
      // UI 側の v-if では二重クリックを防げないため、addSchedule と同じ上限ガードを入れる。
      if (this.schedules.length >= 5) return;
      let minutes = this.addPopupMinutes;
      this.schedules.push(this.createScheduleFromPrevious(minutes));
      this.showAddPopup = false;
      this.addPopupMinutes = '5';
      this.$nextTick(() => {
        this.activeTab = this.schedules.length - 1;
        this.$nextTick(() => {
          this.scrollToScheduleField(this.activeTab, 'title');
        });
      });
    },
    addSchedule: function () {
      if (this.schedules.length >= 5) return;
      this.schedules.push({
        sendAfterMinutes: '5',
        messageTitle: null,
        messageText: null,
        clickUrl: null,
        requireInteraction: '0',
        iconUrl: null,
        selectedIconFile: null,
        largeImageUrl: null,
        selectedLargeImageFile: null,
        badgeUrl: null,
        selectedBadgeFile: null,
        errors: { icon: '', largeImage: '', badge: '' },
      });
      this.$nextTick(() => {
        this.activeTab = this.schedules.length - 1;
      });
    },
    confirmDeleteSchedule: function (index) {
      this.deleteConfirmIndex = index;
    },
    doDeleteSchedule: function () {
      let idx = this.deleteConfirmIndex;
      this.schedules.splice(idx, 1);
      if (this.activeTab >= this.schedules.length) {
        this.activeTab = Math.max(0, this.schedules.length - 1);
      }
      this.deleteConfirmIndex = null;
    },
    removeSchedule: function (index) {
      this.schedules.splice(index, 1);
      if (this.activeTab >= this.schedules.length) {
        this.activeTab = Math.max(0, this.schedules.length - 1);
      }
    },
    toggleImageAccordion: function (index) {
      this.imageAccordionOpen[index] = !this.imageAccordionOpen[index];
    },

    // プレビュークリック連動
    scrollToScheduleField: function (tabIndex, fieldName) {
      this.activeTab = tabIndex;
      this.$nextTick(() => {
        let container = this.$el.querySelector('[data-schedule-index="' + tabIndex + '"]');
        if (!container) return;
        let target = null;
        switch (fieldName) {
        case 'timing':
          target = container.querySelector('[name="schedule_send_after_minutes_' + tabIndex + '"]');
          break;
        case 'title':
          target = container.querySelector('[name="schedule_title_' + tabIndex + '"]');
          break;
        case 'body':
          target = container.querySelector('[name="schedule_message_' + tabIndex + '"]');
          break;
        case 'image':
          this.imageAccordionOpen[tabIndex] = true;
          this.$nextTick(() => {
            target = container.querySelector('.reminder-image-section');
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
          return;
        }
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            target.focus();
          }, 300);
        }
      });
    },
    onPreviewCardClick: function (event, idx) {
      let card = event.currentTarget;
      let iconEl = card.querySelector('.p-message-preview__icon');
      let imageEl = card.querySelector('.p-message-preview__image');
      let titleEl = card.querySelector('.p-message-preview-content__title');
      let textEl = card.querySelector('.p-message-preview-content__text');

      if (iconEl && (iconEl === event.target || iconEl.contains(event.target))) {
        this.onPreviewClickIcon(idx);
        return;
      }
      if (imageEl && (imageEl === event.target || imageEl.contains(event.target))) {
        this.onPreviewClickLargeImage(idx);
        return;
      }
      if (titleEl && (titleEl === event.target || titleEl.contains(event.target))) {
        this.scrollToScheduleField(idx, 'title');
        return;
      }
      if (textEl && (textEl === event.target || textEl.contains(event.target))) {
        this.scrollToScheduleField(idx, 'body');
        return;
      }
    },
    onPreviewClickIcon: function (idx) {
      this.activeTab = idx;
      this.imageAccordionOpen[idx] = true;
      this.$nextTick(() => {
        let container = this.$el.querySelector('[data-schedule-index="' + idx + '"]');
        if (!container) return;
        let fileInput = container.querySelector('[name="schedule_icon_' + idx + '"]');
        if (fileInput) {
          fileInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            fileInput.click();
          }, 300);
        }
      });
    },
    onPreviewClickLargeImage: function (idx) {
      this.activeTab = idx;
      this.imageAccordionOpen[idx] = true;
      this.$nextTick(() => {
        let container = this.$el.querySelector('[data-schedule-index="' + idx + '"]');
        if (!container) return;
        let fileInput = container.querySelector('[name="schedule_large_image_' + idx + '"]');
        if (fileInput) {
          fileInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            fileInput.click();
          }, 300);
        }
      });
    },
    scrollToAddPopup: function () {
      let tabsEl = this.$el.querySelector('.reminder-tabs');
      if (tabsEl) {
        tabsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      this.$nextTick(() => {
        this.showAddPopup = true;
      });
    },
    previewDisplayTitle: function (schedule) {
      let title = this.replacePlaceholders(schedule.messageTitle);
      return title || '(未入力)';
    },
    previewDisplayText: function (schedule) {
      let text = this.replacePlaceholders(schedule.messageText);
      return text || '(未入力)';
    },
    openTimingEdit: function (idx) {
      this.editTimingMinutes = String(this.schedules[idx].sendAfterMinutes || '');
      this.editTimingIdx = idx;
    },
    saveTimingEdit: function (idx) {
      this.schedules[idx].sendAfterMinutes = this.editTimingMinutes;
      this.editTimingIdx = null;
    },
    tabHasError: function (index) {
      return this.tabErrorIndices.indexOf(index) !== -1;
    },
    addScheduleFromPreview: function () {
      // UI 側の v-if では二重クリックを防げないため、addSchedule と同じ上限ガードを入れる。
      if (this.schedules.length >= 5) return;
      let minutes = this.previewAddPopupMinutes;
      this.schedules.push(this.createScheduleFromPrevious(minutes));
      this.showPreviewAddPopup = false;
      this.previewAddPopupMinutes = '5';
      this.$nextTick(() => {
        this.activeTab = this.schedules.length - 1;
        this.$nextTick(() => {
          this.scrollToScheduleField(this.activeTab, 'title');
        });
      });
    },

    // エラー時にタブ切り替え
    scrollToFirstError: function () {
      this.$nextTick(() => {
        let firstError = document.querySelector('.c-error.is-active');
        if (firstError) {
          // エラーのあるスケジュールタブに切り替え
          for (let i = 0; i < this.schedules.length; i++) {
            let scheduleEl = this.$el.querySelector('[data-schedule-index="' + i + '"]');
            if (scheduleEl && scheduleEl.contains(firstError)) {
              this.activeTab = i;
              break;
            }
          }
          this.$nextTick(() => {
            firstError = document.querySelector('.c-error.is-active');
            if (firstError) {
              firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
        }
      });
    },

    getScheduleIconUrl: function (schedule) {
      return schedule.iconUrl || this.messageInfo.defaultIconUrl;
    },
    getScheduleBadgeUrl: function (schedule) {
      return schedule.badgeUrl || this.messageInfo.defaultBadgeUrl;
    },
    replacePlaceholders: function (text) {
      if (!text) return text;
      this.placeholders.forEach((ph) => {
        if (ph.placeholderKey) {
          let replacement = ph.defaultValue || '{{' + ph.placeholderKey + '}}';
          text = text.split('{{' + ph.placeholderKey + '}}').join(replacement);
          text = text.split('{' + ph.placeholderKey + '}').join(replacement);
        }
      });
      return text;
    },
    addPlaceholder: function () {
      this.placeholders.push({ placeholderKey: '', defaultValue: '' });
    },
    removePlaceholder: function (index) {
      if (this.placeholders.length <= 1) {
        this.placeholders[0].placeholderKey = '';
        this.placeholders[0].defaultValue = '';
        this.clearPlaceholderErrors();
      } else {
        this.placeholders.splice(index, 1);
        if (
          this.placeholders.length === 1 &&
          !this.placeholders[0].placeholderKey &&
          !this.placeholders[0].defaultValue
        ) {
          this.clearPlaceholderErrors();
        }
      }
    },
    clearPlaceholderErrors: function () {
      var self = this;
      this.placeholders.forEach(function (ph, i) {
        ['placeholder_key_', 'placeholder_default_'].forEach(function (prefix) {
          var el = self.findErrorElement(prefix + i);
          if (el && el[0]) {
            el.removeClass('is-active');
            el.find('.c-error__text').text('');
            el.closest('.c-input').removeClass('is-error');
          }
        });
      });
    },
    checkNumberFormat(value) {
      return Number(value) >= 0 && /^[\d]+$/.test(value);
    },
    extractPlaceholderKeys: function (text) {
      if (!text) return [];
      let keys = [];
      let regex = /\{\{(.+?)\}\}/g;
      let match;
      while ((match = regex.exec(text)) !== null) {
        if (keys.indexOf(match[1]) === -1) {
          keys.push(match[1]);
        }
      }
      return keys;
    },
    validatePlaceholderKeysInText: function (text, errors, errorKey) {
      let definedKeys = this.placeholders.map((ph) => ph.placeholderKey).filter((k) => k);
      let usedKeys = this.extractPlaceholderKeys(text);
      let undefinedKeys = usedKeys.filter((k) => definedKeys.indexOf(k) === -1);
      if (undefinedKeys.length > 0) {
        errors[errorKey] = '存在しない差し込みテキストのキー名が設定されています';
        return false;
      }
      return true;
    },
    onSaveClick: function () {
      if (this.validate()) {
        this.isLoadingSaveBtn = true;
        this.saveMessage(this.messageInfo.listUrl);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
        this.scrollToFirstError();
      }
    },
    checkMessageFormat(text) {
      const pattern = /[<>]/g;
      return !pattern.test(text);
    },
    checkLength(text, max) {
      return text.length <= max;
    },
    validateClickUrl(url) {
      var replaced = url.replace(/\{\{[^}]+\}\}/g, 'https://placeholder.example.com');
      if (!/^https?:\/\//.test(replaced)) {
        return 'URLはhttp://またはhttps://で始めてください';
      }
      if (/\s/.test(url)) {
        return 'URLにスペースを含めることはできません';
      }
      if (url.length > 2000) {
        return 'URLは2000文字以内で入力してください';
      }
      return null;
    },
    validate: function () {
      this.clearErrors();
      this.tabErrorIndices = [];
      this.schedules.forEach((s) => {
        s.errors = { icon: '', largeImage: '', badge: '' };
      });
      let errors = {};

      if (!this.reminderLabel) {
        errors['reminder_id'] = 'リマインダーIDを入力してください';
      } else if (!/^[a-zA-Z0-9\-_]+$/.test(this.reminderLabel)) {
        errors['reminder_id'] = 'リマインダーIDは半角英数字とハイフン(-)、アンダースコア(_)のみ使用できます';
      } else if (this.reminderLabel.length > 100) {
        errors['reminder_id'] = 'リマインダーIDは100文字以内で入力してください';
      }

      if (this.deliverMode === 'immediate') {
        if (!this.message.messageTitle) {
          errors['message_title'] = 'タイトルを入力してください';
        } else if (!this.checkMessageFormat(this.message.messageTitle)) {
          errors['message_title'] = '使用出来ない文字が含まれています';
        } else if (!this.checkLength(this.message.messageTitle, 140)) {
          errors['message_title'] = 'タイトルは140文字以内で入力してください';
        } else {
          this.validatePlaceholderKeysInText(this.message.messageTitle, errors, 'message_title');
        }

        if (!this.message.messageText) {
          errors['message_content'] = '本文を入力してください';
        } else if (!this.checkMessageFormat(this.message.messageText)) {
          errors['message_content'] = '使用出来ない文字が含まれています';
        } else if (!this.checkLength(this.message.messageText, 1024)) {
          errors['message_content'] = '本文は1024文字以内で入力してください';
        } else {
          this.validatePlaceholderKeysInText(this.message.messageText, errors, 'message_content');
        }
      }

      if (this.deliverMode === 'reminder') {
        this.schedules.forEach((schedule, index) => {
          if (schedule.sendAfterMinutes == null || schedule.sendAfterMinutes === '') {
            errors['schedule_send_after_minutes_' + index] = '何分後に配信するか入力してください';
          } else if (!this.checkNumberFormat(schedule.sendAfterMinutes) || Number(schedule.sendAfterMinutes) < 1) {
            errors['schedule_send_after_minutes_' + index] = '1以上の半角数字で入力してください';
          }

          if (!schedule.messageTitle) {
            errors['schedule_title_' + index] = 'タイトルを入力してください';
          } else if (!this.checkMessageFormat(schedule.messageTitle)) {
            errors['schedule_title_' + index] = '使用出来ない文字が含まれています';
          } else if (!this.checkLength(schedule.messageTitle, 300)) {
            errors['schedule_title_' + index] = 'タイトルは300文字以内で入力してください';
          } else {
            this.validatePlaceholderKeysInText(schedule.messageTitle, errors, 'schedule_title_' + index);
          }

          if (!schedule.messageText) {
            errors['schedule_message_' + index] = '本文を入力してください';
          } else if (!this.checkMessageFormat(schedule.messageText)) {
            errors['schedule_message_' + index] = '使用出来ない文字が含まれています';
          } else {
            this.validatePlaceholderKeysInText(schedule.messageText, errors, 'schedule_message_' + index);
          }

          if (!schedule.clickUrl) {
            errors['schedule_click_url_' + index] = 'URLを入力してください';
          } else {
            var urlError = this.validateClickUrl(schedule.clickUrl);
            if (urlError) {
              errors['schedule_click_url_' + index] = urlError;
            } else {
              this.validatePlaceholderKeysInText(schedule.clickUrl, errors, 'schedule_click_url_' + index);
            }
          }
        });
      }

      var activePlaceholders = this.placeholders.filter(function (ph) {
        return ph.placeholderKey || ph.defaultValue;
      });
      if (this.placeholders.length === 1 && activePlaceholders.length === 0) {
        // 1件のみで空 → 0件扱い、バリデーションスキップ
      } else {
        this.placeholders.forEach((ph, index) => {
          if (!ph.placeholderKey) {
            errors['placeholder_key_' + index] = '差し込みテキストを入力してください';
          } else if (!this.checkLength(ph.placeholderKey, 500)) {
            errors['placeholder_key_' + index] = '差し込みテキストは500文字以内で入力してください';
          }
          if (ph.defaultValue && !this.checkLength(ph.defaultValue, 500)) {
            errors['placeholder_default_' + index] = 'デフォルトテキストは500文字以内で入力してください';
          }
        });
      }

      if (
        (this.workingStartTime == null && this.workingEndTime != null) ||
        (this.workingStartTime != null && this.workingEndTime == null)
      ) {
        errors['working_start_time'] = '片方のみの入力はできません';
        errors['working_end_time'] = '片方のみの入力はできません';
      }

      if (Object.keys(errors).length > 0) {
        let errorIndices = [];
        Object.keys(errors).forEach((key) => {
          let match = key.match(/schedule_(?:send_after_minutes|title|message|click_url)_(\d+)/);
          if (match && errorIndices.indexOf(Number(match[1])) === -1) {
            errorIndices.push(Number(match[1]));
          }
        });
        this.tabErrorIndices = errorIndices;
        this.showErrors(errors);
        return false;
      }

      return true;
    },
    appendForm(params, name, value) {
      if (value !== null && value !== undefined) {
        params.append(name, value);
      }
    },
    saveMessage: function (completeUrl) {
      let params = new FormData();
      this.appendForm(params, 'message_id', this.messageId);
      this.appendForm(params, 'reminder_id', this.reminderLabel);
      this.appendForm(params, 'reminder_note', this.reminderNote);
      this.appendForm(params, 'deliver_mode', this.deliverMode);
      this.appendForm(params, 'working_start_time', this.workingStartTime);
      this.appendForm(params, 'working_end_time', this.workingEndTime);
      this.appendForm(params, 'use_large_image_placeholder', this.useLargeImagePlaceholder);

      if (this.deliverMode === 'immediate') {
        this.appendForm(params, 'message_title', this.message.messageTitle);
        this.appendForm(params, 'message_text', this.message.messageText);
      } else {
        this.schedules.forEach((schedule, index) => {
          this.appendForm(params, 'schedules[' + index + '][send_after_minutes]', schedule.sendAfterMinutes);
          this.appendForm(params, 'schedules[' + index + '][message_title]', schedule.messageTitle);
          this.appendForm(params, 'schedules[' + index + '][message_text]', schedule.messageText);
          this.appendForm(params, 'schedules[' + index + '][click_url]', schedule.clickUrl);
          this.appendForm(params, 'schedules[' + index + '][require_interaction]', schedule.requireInteraction);
          this.appendForm(params, 'schedules[' + index + '][icon_url]', schedule.iconUrl);
          this.appendForm(params, 'schedules[' + index + '][large_image_url]', schedule.largeImageUrl);
          this.appendForm(params, 'schedules[' + index + '][badge_image_url]', schedule.badgeUrl);
          if (schedule.selectedIconFile) {
            params.append('schedule_icon_file_' + index, schedule.selectedIconFile);
          }
          if (schedule.selectedLargeImageFile) {
            params.append('schedule_large_image_file_' + index, schedule.selectedLargeImageFile);
          }
          if (schedule.selectedBadgeFile) {
            params.append('schedule_badge_file_' + index, schedule.selectedBadgeFile);
          }
        });
      }

      var savePlaceholders = this.placeholders.filter(function (ph) {
        return ph.placeholderKey;
      });
      savePlaceholders.forEach((ph, index) => {
        this.appendForm(params, 'placeholders[' + index + '][placeholder_key]', ph.placeholderKey);
        this.appendForm(params, 'placeholders[' + index + '][default_value]', ph.defaultValue || '');
      });

      axios
        .post('/api/reminder/message/save', params)
        .then((res) => {
          if (res.data && res.data.result === 'OK') {
            var url = new URL(completeUrl, location.origin);
            if (res.data.message_id) {
              url.searchParams.append('message_id', res.data.message_id);
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage =
              res && res.data && res.data.message ? res.data.message : 'メッセージの保存に失敗しました';
          }
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        });
    },
    onCloseErrorModal: function () {
      this.isError = false;
      this.errorMessage = '';
    },

    isAcceptableMimeType: function (mimeType) {
      return this.acceptableMimeTypes.includes(mimeType);
    },
    selectIconFile: function (event, index) {
      let iconFile = event.target.files[0];
      if (!iconFile) return;

      if (!this.isAcceptableMimeType(iconFile.type)) {
        this.isError = true;
        this.errorMessage = '通知アイコンはPNG/JPEG/GIF形式のファイルを指定してください。';
        this.schedules[index].errors.icon = '通知アイコンはPNG/JPEG/GIF形式のファイルを指定してください。';
        return;
      }

      this.schedules[index].errors.icon = '';
      this.schedules[index].selectedIconFile = iconFile;
      this.currentCropScheduleIndex = index;
      this.currentCropInput = event.target;

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        const img = new Image();
        img.addEventListener('load', () => {
          const isSquare = img.width === img.height;
          const isSmallEnough = iconFile.size <= 8192;

          if (isSquare && isSmallEnough) {
            this.schedules[index].iconUrl = reader.result;
          } else {
            this.schedules[index].selectedIconFile = null;
            this.$refs.imageCropperModal.showModal(iconFile);
          }
        });
        img.src = reader.result;
      });
      reader.readAsDataURL(iconFile);
    },
    onIconCropped: function (croppedFile) {
      let idx = this.currentCropScheduleIndex;
      this.schedules[idx].selectedIconFile = croppedFile;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          this.schedules[idx].iconUrl = reader.result;
        },
        false
      );
      reader.readAsDataURL(croppedFile);
      if (this.currentCropInput) {
        this.currentCropInput.value = '';
      }
    },
    onIconCropCancelled: function () {
      if (this.currentCropInput) {
        this.currentCropInput.value = '';
      }
    },
    selectLargeImageFile: function (event, index) {
      let largeImageFile = event.target.files[0];
      if (!largeImageFile) return;

      this.schedules[index].errors.largeImage = '';

      if (!this.isAcceptableMimeType(largeImageFile.type)) {
        this.isError = true;
        this.errorMessage = '追加大型画像はPNG/JPEG/GIF形式のファイルを指定してください。';
        this.schedules[index].errors.largeImage = '追加大型画像はPNG/JPEG/GIF形式のファイルを指定してください。';
        return;
      }

      this.schedules[index].selectedLargeImageFile = largeImageFile;
      this.currentCropScheduleIndex = index;
      this.currentCropInput = event.target;
      const isSmallEnough = largeImageFile.size <= 131072;

      if (isSmallEnough) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.schedules[index].largeImageUrl = reader.result;
        });
        reader.readAsDataURL(largeImageFile);
      } else {
        this.schedules[index].selectedLargeImageFile = null;
        this.$refs.imageCropperModalLarge.showModal(largeImageFile);
      }
    },
    onLargeImageCropped: function (croppedFile) {
      let idx = this.currentCropScheduleIndex;
      this.schedules[idx].selectedLargeImageFile = croppedFile;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          this.schedules[idx].largeImageUrl = reader.result;
        },
        false
      );
      reader.readAsDataURL(croppedFile);
      if (this.currentCropInput) {
        this.currentCropInput.value = '';
      }
    },
    onLargeImageCropCancelled: function () {
      if (this.currentCropInput) {
        this.currentCropInput.value = '';
      }
    },
    clearLargeImageFile: function (index) {
      this.schedules[index].selectedLargeImageFile = null;
      this.schedules[index].largeImageUrl = '';
      let input = this.$el.querySelector('[name="schedule_large_image_' + index + '"]');
      if (input) input.value = '';
    },
    selectBadgeFile: function (event, index) {
      let badgeFile = event.target.files[0];
      this.schedules[index].errors.badge = '';

      if (badgeFile.size > 8192) {
        this.isError = true;
        this.errorMessage = 'ステータスアイコンは8KB以下のファイルを指定してください。';
        this.schedules[index].errors.badge = 'ステータスアイコンは8KB以下のファイルを指定してください';
        return;
      }

      if (badgeFile.type != 'image/png') {
        this.isError = true;
        this.errorMessage = 'ステータスアイコンはPNG形式のファイルを指定してください。';
        this.schedules[index].errors.badge = 'ステータスアイコンはPNG形式のファイルを指定してください。';
        return;
      }

      const fileReader = new FileReader();
      this.checkImageTransparency(fileReader, index);
      fileReader.readAsDataURL(badgeFile);

      this.schedules[index].selectedBadgeFile = badgeFile;
    },
    clearBadgeFile: function (index) {
      this.schedules[index].selectedBadgeFile = null;
      this.schedules[index].badgeUrl = '';
      let input = this.$el.querySelector('[name="schedule_badge_' + index + '"]');
      if (input) input.value = '';
    },
    checkImageTransparency: function (fileReader, index) {
      fileReader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const alphaChannel = imageData.data.filter((_, i) => (i + 1) % 4 === 0);
          if (alphaChannel.some((alpha) => alpha !== 255)) {
            this.schedules[index].badgeUrl = fileReader.result;
          } else {
            this.isError = true;
            this.errorMessage = 'ステータスアイコンは透過されたPNG形式のファイルを指定してください。';
            this.schedules[index].errors.badge = 'ステータスアイコンは透過されたPNG形式のファイルを指定してください。';
          }
        };
        img.src = fileReader.result;
      };
    },
  },
};
</script>

<style scoped>
.c-input__note li {
  list-style: none;
}
.p-message-edit-list-cart__container .c-error--balloon,
.c-error--balloon[data-error-anchor] {
  width: fit-content;
  white-space: nowrap;
}
.placeholder-row--no-title .c-error--balloon {
  top: auto;
  bottom: 100%;
  margin-bottom: 2px;
}
.reminder-note-textarea {
  resize: vertical;
  height: 70px;
}
.c-input__note li::before {
  content: '- ';
}
/* プレビュー */
.p-message-preview .p-message-preview-list {
  padding-bottom: 20px;
}
.preview-list--compact {
  padding-top: 5px;
}

/* タブナビゲーション */
.reminder-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e5e5e5;
  margin-bottom: 20px;
  position: relative;
}
.reminder-tabs__item {
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  color: #999;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
}
.reminder-tabs__item:hover {
  color: #666;
  background: rgba(60, 182, 210, 0.05);
}
.reminder-tabs__item.is-active {
  font-weight: 700;
  color: #209bb9;
  border-bottom-color: #3cb6d2;
}
.reminder-tabs__item.has-error {
  background: #fde8ec;
  color: #f2657f;
}
.reminder-tabs__item.has-error.is-active {
  background: #fde8ec;
  color: #f2657f;
  border-bottom-color: #f2657f;
}
.reminder-tabs__add {
  padding: 10px 16px;
  font-size: 13px;
  color: #3cb6d2;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.15s;
  border-radius: 6px 6px 0 0;
  position: relative;
}
.reminder-tabs__add:hover {
  background: rgba(60, 182, 210, 0.08);
}

/* 追加ポップアップ */
.reminder-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
.reminder-add-popup {
  position: absolute;
  z-index: 2500;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 340px;
  right: 0;
  top: 42px;
}
.reminder-add-popup__title {
  font-size: 13px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.reminder-add-popup__desc {
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

/* 画像アコーディオン */
.reminder-image-section {
  border-top: 1px solid #e5e5e5;
  padding-top: 16px;
  margin-top: 20px;
}
.reminder-image-section__outer {
  position: relative;
}
.reminder-image-section__body {
  max-height: 120px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.reminder-image-section__body.is-open {
  max-height: 2000px;
  overflow: visible;
}
.reminder-image-section__mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(238, 243, 246, 0) 0%, rgba(238, 243, 246, 1) 100%);
  cursor: pointer;
  z-index: 1;
  transition: opacity 0.15s;
}
.reminder-image-section__outer:hover .reminder-image-section__mask {
  background: linear-gradient(to bottom, rgba(238, 243, 246, 0) 0%, rgba(238, 243, 246, 0.6) 100%);
}
.reminder-image-section__toggle-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.reminder-image-section__toggle-btn {
  display: inline-block;
  padding: 6px 18px;
  font-size: 12px;
  font-weight: 700;
  color: #3cb6d2;
  background: #fff;
  border: 1px solid #3cb6d2;
  border-radius: 20px;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.15s;
  white-space: nowrap;
}
.reminder-image-section__toggle-btn:hover,
.reminder-image-section__outer:hover .reminder-image-section__toggle-btn {
  background: #d8f0f6;
}

/* プレビュー内タイミング・ラベル行 */
.preview-schedule-separator {
  color: #999;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 12px 8px;
  position: relative;
  text-align: center;
}

/* タイミングテキストをボタン化 */
.preview-timing-btn {
  display: inline-block;
  background: #fff;
  border: 1px solid #3cb6d2;
  border-radius: 14px;
  padding: 3px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #3cb6d2;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.preview-timing-btn:hover {
  background: #d8f0f6;
}

/* タイミング編集ポップアップ */
.preview-timing-popup {
  position: absolute;
  z-index: 2500;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 340px;
  left: 50%;
  transform: translateX(-50%);
  top: 36px;
  text-align: left;
}
.preview-schedule-label {
  font-size: 12px;
  font-weight: normal;
  color: #333;
  padding: 0 0 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* プレビュー内操作ボタン */
.preview-action-btn {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  transition: all 0.15s;
  white-space: nowrap;
  font-family: inherit;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.preview-action-btn--delete {
  color: #999;
  background: #fff;
  border: 1px solid #ccc;
}
.preview-action-btn--delete:hover {
  background: #f5f5f5;
  border-color: #999;
}

/* プレビューカード */
.preview-card-interactive {
  border-radius: 6px;
}

/* アイコン画像のホバーオーバーレイ (子コンポーネントへ深層適用) */
.preview-card-interactive :deep(.p-message-preview__icon) {
  position: relative;
  cursor: pointer;
}
.preview-card-interactive :deep(.p-message-preview__icon::after) {
  content: '編集';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
}
.preview-card-interactive :deep(.p-message-preview__icon:hover::after) {
  opacity: 1;
}

/* 大型画像のホバーオーバーレイ */
.preview-card-interactive :deep(.p-message-preview__image) {
  position: relative;
  cursor: pointer;
}
.preview-card-interactive :deep(.p-message-preview__image::after) {
  content: '編集';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
}
.preview-card-interactive :deep(.p-message-preview__image:hover::after) {
  opacity: 1;
}

/* プレビュー内子コンポーネントのクリック対象ハイライト */
.preview-card-interactive :deep(.p-message-preview-content__title),
.preview-card-interactive :deep(.p-message-preview-content__text) {
  cursor: pointer;
  border-radius: 3px;
  transition: outline 0.15s;
  outline: 2px solid transparent;
}
.preview-card-interactive :deep(.p-message-preview-content__title:hover) {
  outline: 2px solid rgba(60, 182, 210, 0.6);
}
.preview-card-interactive :deep(.p-message-preview-content__text:hover) {
  outline: 2px solid rgba(60, 182, 210, 0.6);
}

/* プレビュー内メッセージ追加ボタン */
.preview-add-wrap {
  text-align: center;
  padding: 40px 0 4px;
  position: relative;
}
.preview-add-popup {
  position: absolute;
  z-index: 2500;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 340px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 48px;
  text-align: left;
}
.preview-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #3cb6d2;
  border-radius: 50px;
  padding: 8px 20px;
  font-size: 12px;
  color: #3cb6d2;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  transition: background 0.15s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.preview-add-btn:hover {
  background: rgba(60, 182, 210, 0.08);
}
.preview-add-btn .c-icon-circle--primary {
  background: #3cb6d2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 差し込みテキスト ハイライト */
.placeholder-key-highlight {
  background: #d4f0f7;
  color: #209bb9;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
}

/* 透過画像用チェッカーボード背景 */
.uploaded_transparent_image {
  margin: 0;
  padding: 0;
  background-color: #fff;
  background-image: linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd),
    linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd);
  background-size: 18px 18px;
  background-position: 0 0, 9px 9px;
  overflow: hidden;
}

/* 人間可読表示 */
.time-picker__readable {
  color: #888;
  font-size: 12px;
  font-weight: normal;
}

/* 入力欄 */
.time-picker__input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.time-picker__minutes-input {
  width: 110px;
  height: 32px;
  padding: 2px 10px 0;
  line-height: 1;
  text-align: center;
  box-sizing: border-box;
}
.time-picker__minutes-input[readonly] {
  background: #fff;
  cursor: default;
}
.time-picker__unit-label {
  color: #999;
  font-size: 17px;
  flex-shrink: 0;
}
/* ±ステップボタン: 5分刻みでの増減操作用。
   カラーは「配信時間帯を設定する」の nw-time-picker__btn と揃える。
   +/- グリフはフォントの視覚中心が下寄りに描画されるため、
   下 padding を足して flex 中央寄せの計算上のセンターを 1px 上へずらす。 */
.time-picker__step-btn {
  width: 32px;
  height: 32px;
  border: 1.5px solid rgba(60, 182, 210, 0.3);
  background: #fff;
  color: #3cb6d2;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0 0 2px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  transition: all 0.15s;
}
.time-picker__step-btn:hover {
  background: rgba(60, 182, 210, 0.1);
}

/* チップエリア */
.time-picker__chip-area {
  margin-top: 8px;
}
.time-picker__chip-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.time-picker__chip-group:last-child {
  margin-bottom: 0;
}
.time-picker__chip {
  padding: 3px 10px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #f5f5f5;
  cursor: pointer;
  font-size: 11px;
  transition: all 0.15s;
}
.time-picker__chip:hover {
  border-color: #0089e5;
  color: #0089e5;
}
.time-picker__chip.is-selected {
  background: #e8f4fd;
  border-color: #0089e5;
  color: #0089e5;
}

/* 削除確認ダイアログ */
.reminder-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reminder-confirm-dialog {
  background: #fff;
  border-radius: 10px;
  padding: 30px;
  width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  text-align: center;
}
.reminder-confirm-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
}
.reminder-confirm-dialog__body {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}
.reminder-confirm-dialog__btns {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.placeholder-remove-btn {
  cursor: pointer;
  padding-top: 8px;
  transition: opacity 0.15s;
}
.placeholder-remove-btn:hover {
  opacity: 0.5;
}
</style>
